import "../helpers/api_helper";
import axios from "axios";

const base = () => axios.defaults.baseURL || "";

function authHeaders() {
  const token = localStorage.getItem("accessToken");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function getRewardEngine() {
  return axios.get(`${base()}merchant/reward-engine`, {
    headers: { ...authHeaders() },
  });
}

export async function patchRewardEngine(body) {
  return axios.patch(`${base()}merchant/reward-engine`, body, {
    headers: { ...authHeaders(), "Content-Type": "application/json" },
  });
}
